import model from "./model";
import { showNotification } from "./management/notifications-management";
import { fetchResource } from "./services/web-res-service";
import type { CategoryID } from "./types/category-id-types";
import { getLangText, redeemLangObj } from "@/ts/utils/model-utils";
import { navigateTo } from "./management/view-navigation-management";
import globalImport from "./utils/global-import";
import { removeFlutterInFlightReq } from "./management/flutter-management";

export default {
    async openTermsAndCond(){
        return await loadLegalDoc('terms-and-conditions');
    },
    async openPrivacyPolicy(){
        return await loadLegalDoc('privacy-policy');
    },
    async navigateTo(viewId: CategoryID){
        return await navigateTo(viewId);
    },
    openChat(){
        if(window.initZendesk) {
            const disposable = model.on('ZendeskLoaded', () => { 
                disposable();
                onShow();
            });
            window.initZendesk();
            return;
        }

        onShow();
        function onShow(){
            window?.$zopim?.livechat?.window?.show?.();
        }
    },
    loginUser(username: string, pass: string){
        if(model.uToken){
            removeFlutterInFlightReq('Flutter_WebView_RequestLogin');
            model.dispatch('GetStoredPass', {
                detail: { pass },
            });
            return;
        }

        model.storedUsername = username;
        globalImport(() => import("./services/casino/casino-login-service")).then(module => {
            module.sendUserLoginRequest(username, pass, false);
        });
    },
    onUserVerificationComplete(){
        globalImport(() => import("./services/casino/casino-user-data-service")).then(module => module.sendLoadUserRequest())
    },
    showCashierReceipt(){
        model.dispatch('ClosePaymentWindow');
    },
};

async function loadLegalDoc(id: CategoryID){
    let page = model.clientConfig.webRes?.pages?.find(x => x.id == id);
    if(!page?.path) return;

    let textHtml = await fetchResource(redeemLangObj(page.path), 'text', true);
    if(typeof textHtml !== 'string') return;

    let html = new DOMParser().parseFromString(textHtml, 'text/xml');
    let content = html.querySelector('html')?.textContent;

    showNotification({
        title: getLangText(page.label),
        text: content,
    });
}